import WebApp from '@twa-dev/sdk';
import http from './http';
import { LoginTokenDto } from './login/token';
import { PetHomeDto } from './game/game';
import { InviteAllDto } from './invite/all';
import { UserSettingParams } from './user/setting';
import { SpinHandleDto, SpinHandleParam } from './spin/handle';
import { SpinRecentDto } from './spin/recent';
import { SpinDetailDto } from './spin/detail';
import { TaskUpdateParams } from './task/update';
import { EarnTaskListDto } from './task/list';
import { InviteAddParams } from './invite/add';
import { InviteListDto } from './invite/list';
import { CheckinDailyDto } from './checkin/daily';
import { CheckinStatusDto } from './checkin/status';
import { UserAccountDto } from './user/account';
import { getStartParams } from '@/utils';
import { InviteCountParams } from './invite/count';
import { GameListDto, GameStartDto, GameStartParam, GameStatusDto, GameStatusParam } from './game/provider';
import { EventBagDto, EventRankItemDto, EventTreeDataDto, EventStoreDto, EventBuyDto } from './event/christmas';
import { TicketData } from './raffle/raffle';

const login = {
  token: (param: { idToken: string }) => {
    const p = {
      picture: WebApp.initDataUnsafe.user?.photo_url,
      loginSource: 'miniApp',
      ...param,
    };

    return http.post<LoginTokenDto>(`/ico/login/token?i=${getStartParams()}`, p);
  },
};

const game = {
  /** 获取Tap主页信息 */
  petHome: () => {
    return http.get<PetHomeDto>('/ico/game/pet/home/');
  },

  /** 点击收集金币 */
  tapCoins: (count: number) => {
    return http.post<Boolean>('/ico/game/tap/coins/', { tapNum: count });
  },

  /** 恢复体力满状态 */
  restoreEnergy: () => {
    return http.get<Boolean>('/ico/game/restore/energy/');
  },

  /** 升级体力上限 */
  upgradeEnergy: () => {
    return http.post<Boolean>('/ico/game/upgrade/energy/');
  },

  /** 升级点击上限 */
  upgradeMultiTap: () => {
    return http.post<Boolean>('/ico/game/upgrade/multi/');
  },

  /* 神秘彩蛋验证码 */
  verify: (param: {password: string}) => {
    return http.get<string>('/ico/mystery/egg/verify/' + param.password)
  },

  /* 领取礼物 */
  receive: () => {
    return http.get('/ico/mystery/egg/receive/gift')
  },

  del: () => {
    return http.get('/ico/mystery/egg/del')
  }
};

const user = {
  getSetting: () => {
    return http.get<UserSettingParams>('/ico/user/setting/');
  },
  updateSetting: (param: UserSettingParams) => {
    return http.post<UserSettingParams>('/ico/user/setting/', param);
  },
  account: () => {
    return http.get<UserAccountDto>('/ico/account/');
  },
  bindBcUid: (param: { bcUserId: string }) => {
    return http.post<Boolean>('/ico/account/bindBc/', param);
  },
  queryBindStatus: () => {
    return http.get<Boolean>('/ico/account/bindBc/');
  },
};

const withdraw = {
  bc: (params: { currencyName: string; amount: number }) => {
    return http.post<any>('/ico/withdraw/bc', params);
  }
}

const spin = {
  /** 抽奖 */
  handle: (param: SpinHandleParam) => {
    return http.post<SpinHandleDto>('/ico/spin/handle/', param);
  },
  /** 最近抽奖记录 */
  recent: () => {
    return http.get<SpinRecentDto>('/ico/spin/recent/');
  },
  /** 用户抽奖详情 */
  detail: () => {
    return http.get<SpinDetailDto>(`/ico/spin/detail/`);
  },
};

const task = {
  /** 更新任务状态 */
  update: (param: TaskUpdateParams) => {
    return http.post<Boolean>('/ico/task/update/', param);
  },
  /** 获取任务列表 */
  list: () => {
    return http.get<EarnTaskListDto>('/ico/task/list/');
  },

  // 等级检查
  levelCheck: (param: { taskId: number }) => {
    return http.get<Boolean>('/ico/level/check/' + param.taskId);
  },

  // check 部分任务有
  checkStatus: (param: { taskId: number }) => {
    return http.get<Boolean>('ico/task/check/' + param.taskId);
  },

  claim: () => {
    return http.get('/ico/task/claim')
  },

  mysteryBoxTasksCompleted: () => {
    return http.get('/ico/task/mysteryBoxTasksCompleted')
  }

};

const invite = {
  /** 获取所有邀请奖励 */
  all: () => {
    return http.get<InviteAllDto>('/ico/invite/record/all/');
  },
  add: (param: InviteAddParams) => {
    return http.post<Boolean>('/ico/invite/record/add/', param);
  },
  /** 获取邀请奖励列表 */
  list: () => {
    return http.get<InviteListDto>('/ico/invite/record/list/');
  },
  link: () => {
    return http.post<String>('/ico/invite/link/');
  },
  code: () => {
    return http.post<String>('/ico/invite/code/');
  },
  rank: () => {
    return http.get<InviteListDto>('/ico/invite/record/rank/top-200/');
  },
  /** 获取邀请人数 */
  count: () => {
    return http.get<InviteCountParams>('/ico/invite/record/count/');
  },
  getOpenIdByCode: (code: string) => {
    return http.get<String>('/ico/invite/uid/' + code);
  },

  weekRank: () => {
    return http.get('/ico/invite/record/rank/week')
  }
};

const checkin = {
  /** 获取每日签到记录 */
  daily: () => {
    return http.get<CheckinDailyDto>('/ico/checkin/christmas/daily/');
  },
  status: () => {
    return http.get<CheckinStatusDto>('/ico/checkin/christmas/status');
  },
  countdown: () => {
    return http.get<number>('/ico/checkin/christmas/countdown');
  }
};

const setting = {
  get: () => {
    return http.get<UserSettingParams>('/ico/user/setting/get');
  },
  save: (param: UserSettingParams) => {
    return http.post<UserSettingParams>('/ico/user/setting/update', param);
  },
}

const gameProvider = {

  list: () => {
    return http.get<GameListDto>('/ico/provider/mobile/list/');
  },
  start: (param: GameStartParam) => {
    return http.post<GameStartDto>('/ico/provider/game-start', param);
  },
  status: (param: GameStatusParam) => {
    return http.post<GameStatusDto>('/ico/provider/game-online-player', param);
  },
}

const event = {
  /* 圣诞树 */
  tree: (openId: number) => {
    return http.get<EventTreeDataDto>('/ico/christmas/operation/list/' + openId);
  },

  remove: (param: {itemId: number, sort: number}) => {
    return http.post<any>('/ico/christmas/operation/tree/item/remove/', param);
  },

  /* 背包 */
  bag: (id: number) => {
    return http.get<EventBagDto[]>('/ico/christmas/bag/query/' + id);
  },

  add: (param: object) => {
    return http.post<any>('/ico/christmas/operation/tree/item/add/', param);
  },

  /* 商店 */
  store: (id: number) => {
    return http.get<EventStoreDto>('/ico/christmas/store/list/' + id);
  },

  buy: (param: object) => {
    return http.post<EventBuyDto>('/ico/christmas/store/purchase/', param);
  },

  /* 排行榜 */
  ranking: () => {
    return http.get<EventRankItemDto[]>('/ico/christmas/rank/page/');
  },

  rankMySelf: () => {
    return http.get<EventRankItemDto>('/ico/christmas/rank/myself/');
  },

  throwBall: (param: { toUserTgOpenId: number }) => { 
    return http.post('/ico/christmas/operation/throw/snowball/', param);
  }

}

// 待补充返回类型
const airdrop = {
  info: () => {
    return http.post('/ico/bcdrop/info/')
  },
  claim: () => {
    return http.post('/ico/bcdrop/claim/')
  },
  history: () => {
    return http.post('/ico/bcdrop/claim/history/')
  },
  showAnimation: () => {
    return http.post('/ico/bcdrop/animation/')
  },
  animationInfo: () => {
    return http.post('/ico/bcdrop/animation/info')
  }
}


const raffle = {
  raffleInfo: () => {
    return http.get<TicketData>('/ico/wallet/bcpoints/raffleInfo')
  },
  getPoint: () => {
    return http.get('/ico/wallet/bcpoints/get')
  },
  exchangeRaffle: (amount: number) => {
    return http.post('/ico/wallet/bcpoints/exchangeRaffle/' + amount)
  }
}

export default {
  login,
  game,
  user,
  spin,
  task,
  invite,
  checkin,
  setting,
  withdraw,
  gameProvider,
  event,
  airdrop,
  raffle
};
